import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AlertContext } from "../../../context/alertContext";
import { DeploymentContext } from "../../../context/deploymentContext";
import api from "../../../api";
import { acmCertificateForPayload, validateYaml } from "../../../context/helper";
import { dataList } from "../../Tables/AntTables/AntTables";
import { AppContext } from "../../../context/ContextProvider";

export function useDeploymentFeatures(keySelected, setKeySelected, services, setServices, setServiceSelected) {
    // console.log("My services: ", services);
    const { updatedData, setUpdatedData, setUpdateDep, validateYamls, snakeToCamel, setFormErrors, deploymentForms, setToggleApi } = useContext(DeploymentContext);
    const { set_alertOptions } = useContext(AlertContext);
    const { dispatch } = useContext(AppContext);
    const location = useLocation();
    let navigate = useNavigate();
    function toggleAlert(type, message, description) {
        console.log("Toggle alert called: ", type, message, description);
        set_alertOptions({
            status: true,
            type: type,
            message: message,
            description: description,
        });

        // opacity=0 after 10sec
        setTimeout(() => {
            set_alertOptions({
                status: false,
                type: type,
                message: message,
                description: description,
            });
        }, 5 * 1000);
    }
    const redirectToNext = () => {
        /* Commented this out as the new flow doesn't let us update multiple services at once */
        
        // let nextActiveService = "", index;
        // services.forEach((val, idx) => {
        //     if (val.isActive && idx !== keySelected) {
        //         nextActiveService = val;
        //         index = idx;
        //         return;
        //     }
        //     if (idx === keySelected) {
        //         val.isActive = false;
        //         setServices([...services]);
        //     }
        // });
        // if (nextActiveService === "") {
        setUpdatedData({});
        setUpdateDep(false);
        localStorage.removeItem('updateDep');
        localStorage.removeItem('updatedData');
        navigate(`/environments/environment/${location.pathname.split('/').slice(-1)[0]}/env-overview`);
        // }
        // else {
        //     if (nextActiveService !== "") {
        //         setKeySelected(index);
        //         setServiceSelected(nextActiveService);
        //     }
        // }
    }
    const handleApplicationRedeploy = async (appData, currentProjectDep) => {

        let allErrors = [], myErrors = {};
        const allForms = [{
            serviceSelected: appData.basicDetails.serviceName,
            form: deploymentForms[appData.basicDetails.serviceName]
        }];
        let yamls = await validateYamls([appData]);
        let yamlError = false;

        yamls.forEach((val, idx) => {
            if (val && val.data && idx === val.idx) {
                appData.deployments.yamlData = [...val.data];
            }

            else if (val && appData.serviceEnabled) {
                myErrors = {
                    ...myErrors,
                    [val.serviceName]: "Your YAML code provided is invalid."
                };
                allErrors = [...allErrors, {
                    serviceSelected: val.serviceName,
                    error: "Your YAML code provided is invalid."
                }];
                yamlError = true;
            }
        });
        if (allErrors.length > 0) {
            toggleAlert("error", "Error", "Please provide correct yaml file.");
        }
        else {
            console.log("Redeploying app...", appData);
            // console.log("Redeploying app...", keySelected);
            let myConfigVol = [];
            let mySecretVol = [];
            let myStorageVol = [];
            let myEnvs = appData?.environments?.length > 0 ? (appData?.environments?.length === 1 ? (appData.environments[0].name === "" && appData.environments[0].value === "") ? [] : appData.environments : appData.environments) : appData.environments;
            let tags = {};
            appData.deployments?.tags.map((val, idx) => {
                if (val.name !== "" && val.value !== "") {
                    tags[val.name] = val.value;
                }
            })
            let labels = {};
            appData.deployments?.labels?.map((item, idx) => {
                if (item.name !== "" && item.value !== "") {
                    labels[item.name] = item.value;
                }
            })

            appData?.volumes?.map((ele) => {
                if (ele.volumeType === "Configmap") {
                    let rawStr = ele.config.createMountPath.split('/')
                    let tempFilename = rawStr.pop()  // removing filename from rawStr
                    let tempMountPath = rawStr.join("/")   // join for mountPath

                    console.log("tempFilename :", tempFilename)
                    console.log("tempMountPath :", tempMountPath)

                    myConfigVol.push({
                        "name": ele.config.configName,//"test-cm",
                        "filename": tempFilename,//"index.yaml",
                        "mountPath": tempMountPath,//"/app",
                        "data": ele.config.createConfig//"this the configmap data...."
                    });
                }
                else if (ele.volumeType === "Secrets") {
                    let rawStrSecrets = ele.secrets.createSecretsMountPath.split('/')
                    let tempFilenameSecrets = rawStrSecrets.pop()  // removing filename from rawStrSecrets
                    let tempMountPathSecrets = rawStrSecrets.join("/")   // join for mountPath

                    console.log("tempFilenameSecrets :", tempFilenameSecrets)
                    console.log("tempMountPathSecrets :", tempMountPathSecrets)

                    mySecretVol.push({
                        "name": ele.secrets.secretsName,//"test-secretqs",
                        "filename": tempFilenameSecrets,//"index.yaml",
                        "mountPath": tempMountPathSecrets,//"/app",
                        "data": ele.secrets.createSecrets//"this the configmap data...."
                    });
                }
                else if (ele.volumeType === "Storage") {
                    myStorageVol.push({
                        "name": ele.storage.storageDes.storageName,//"test-secrets",
                        "size": ele.storage.storageDes.size !== "" ? ele.storage.storageDes.size : 0,//+ 'Gi' : "",//"10Gi",
                        "mountPath": ele.storage.storageDes.path,//"/app",
                        "storageClass": ele.storage.storageDes.type.toLowerCase() === "efs" ? 'efs-sc' : ele.storage.storageDes.type.toLowerCase(),//"gp2",
                        "accessMode": "ReadWriteOnce"
                    });
                }
            });

            let payload;
            let secret_name = currentProjectDep.tasks?.find(x => x.name === appData?.basicDetails?.serviceName)?.secret_name;
            let accountDetails = currentProjectDep.tasks?.find(x => x.name === appData?.basicDetails?.serviceName)?.accountDetails;
            // console.log("secret_name :", secret_name);
            // console.log("currentProjectDep in redeploy :", currentProjectDep);
            // console.log("accountDetails in redeploy :", accountDetails);
            payload = {
                "name": appData?.basicDetails?.appName ?? appData.name,
                "service_id": appData?.serviceSelectedId ?? appData.service_id,//serviceSelected.id,
                "cd_values_in_yaml": appData?.deployments?.deploymentOption === "yaml" ?? appData.cd_values_in_yaml,
                "config": {
                    "secret_details": accountDetails?.account_id ? {
                        "secret_name": secret_name || "",
                        "region": accountDetails?.region || "",
                        "account_id": accountDetails?.account_id || "",
                        "integration_id": accountDetails?.integration || "",
                    } : null,
                    "app_source_type": appData.basicDetails.sourceType === "Container Registry" ? 0 : 1,
                    "docker_file": appData.basicDetails.sourceType === "Container Registry" ? undefined : './' + appData.basicDetails.dockerFilePath,
                    "build_context": appData.basicDetails.sourceType === "Container Registry" ? undefined : appData.basicDetails.buildContext && appData.basicDetails.buildContext !== "" ? "./" + appData.basicDetails.buildContext : null,
                    "container_registry_id": appData.basicDetails.appSource === "PUBLIC" ? null : appData.basicDetails.sourceType === "Container Registry" ? appData.basicDetails.appSource?.id : appData.basicDetails.containerRegistryId?.id ?? null,
                    "repository_name": appData.basicDetails.imageRepo,
                    "image_tag": appData.basicDetails.imageTag && appData.basicDetails.imageTag !== "" ? appData.basicDetails.imageTag : undefined,
                    "container_registry_type": appData.basicDetails.sourceType === "Container Registry" ? appData.basicDetails.appSource === "PUBLIC" ? 0 : 1 : undefined,
                    "architecture_type": appData.basicDetails.architectureType,
                    "port": appData.deployments.deploymentOption === "visual" ? parseInt(appData.deployments.port) : undefined,
                    "create_storage": appData.deployments.deploymentOption === "visual" ? myStorageVol.length > 0 ? "true" : "false" : undefined,
                    "create_secret": appData.deployments.deploymentOption === "visual" ? mySecretVol.length > 0 ? "true" : "false" : undefined,
                    "ingress_enabled": appData.deployments.deploymentOption === "visual" ? appData.deployments.serviceType.includes("Existing Load Balancer") ? "true" : "false" : undefined,//val.deployments.customDomain === true ? "true" : "false",
                    "ingress_https_enabled": appData.deployments.deploymentOption === "visual" ? "true" : undefined,
                    "ingress_host": appData.deployments.deploymentOption === "visual" ? appData.deployments.domainHostUrl === "" ? "" : appData.deployments.domainHostUrl + '.' + appData.deployments.dns : undefined,
                    "zone_id": appData.deployments.deploymentOption === "visual" ? (appData.deployments.endpointType === "Cluster IP" ? null : appData.deployments.hostedAccount): undefined,
                    "dns_record_type": appData.deployments.deploymentOption === "visual" ? appData.deployments.recordType : undefined,
                    "hosted_zone": appData.deployments.deploymentOption === "visual"? (appData.deployments.endpointType === "Cluster IP" ? "" : appData.deployments.dns): undefined,
                    "ingress_path": appData.deployments.deploymentOption === "visual"? (appData.deployments.endpointType === "Cluster IP"? "/" : (appData.deployments.gatewayHttps.gPath === "" ? "/" : appData.deployments.gatewayHttps.gPath)): undefined,
                    "env_variables": myEnvs,
                    "record_prefix": appData.deployments.deploymentOption === "visual" ? appData.deployments.serviceType.includes("Existing Load Balancer") ? appData.deployments.domainHostUrl : "" : undefined,
                    "service_type": appData.deployments.deploymentOption === "visual" ? (appData.deployments.endpointType === "Cluster IP" || appData.deployments.serviceType.includes("Existing Load Balancer")) ? "ClusterIP" : !appData.deployments.endpointType ? "" : "LoadBalancer" : undefined,//serviceSelected.type,
                    "service_protocol": appData.deployments.deploymentOption === "visual" ? "TCP" : undefined,
                    "enable_plaintext_env": myEnvs.length > 0 ? "true" : "false",
                    "enable_secret_env": myEnvs.length > 0 ? "true" : "false",
                    "vcs_branch": appData.basicDetails.branch === "" ? null : appData.basicDetails.branch,
                    "secretfile_enabled": appData.deployments.deploymentOption === "visual" ? mySecretVol.length > 0 ? "true" : "false" : undefined,
                    "create_configmap": appData.deployments.deploymentOption === "visual" ? myConfigVol.length > 0 ? "true" : "false" : undefined,
                    "cpu_request": appData.deployments.deploymentOption === "visual" ? parseInt(appData.deployments.resources.cpu.requestCpu) : undefined, //+ 'm',
                    "cpu_limit": appData.deployments.deploymentOption === "visual" ? parseInt(appData.deployments.resources.cpu.limitCpu) : undefined, //+ 'm',
                    "memory_request": appData.deployments.deploymentOption === "visual" ? parseInt(appData.deployments.resources.memory.requestMem) : undefined, //+ 'Mi',
                    "memory_limit": appData.deployments.deploymentOption === "visual" ? parseInt(appData.deployments.resources.memory.limitMem) : undefined, //+ 'Mi',
                    "target_cpu_utilization": appData.deployments.deploymentOption === "visual" ? appData.deployments.autoScaling.autoScalingData.autoScalingParameter.cpuAuto === "" ? 0 : parseInt(appData.deployments.autoScaling.autoScalingData.autoScalingParameter.cpuAuto) : undefined, //+ '%',
                    "target_memory_utilization": appData.deployments.deploymentOption === "visual" ? appData.deployments.autoScaling.autoScalingData.autoScalingParameter.memoryAuto === "" ? 0 : parseInt(appData.deployments.autoScaling.autoScalingData.autoScalingParameter.memoryAuto) : undefined, //+ '%',
                    "enable_autoscaling": appData.deployments.deploymentOption === "visual"
                        ? String(appData.deployments.autoScaling?.enabled === true)
                        : undefined,
                    "maximum_replicas": appData.deployments.deploymentOption === "visual" ? appData.deployments.autoScaling.autoScalingData.maximumReplica : undefined,
                    "minimum_replicas": appData.deployments.deploymentOption === "visual" ? appData.deployments.autoScaling.autoScalingData.minimumReplica : undefined,
                    "config_files_config": appData.deployments.deploymentOption === "visual" ? myConfigVol === 1 ? myConfigVol[0].name === "" ? [] : myConfigVol : myConfigVol : undefined,
                    "storages_config": appData.deployments.deploymentOption === "visual" ? myStorageVol.length === 1 ? myStorageVol[0].name === "" ? [] : myStorageVol : myStorageVol : undefined,
                    "secret_files_config": appData.deployments.deploymentOption === "visual" ? mySecretVol.length === 1 ? mySecretVol[0].name === "" ? [] : mySecretVol : mySecretVol : undefined,
                    "tags": Object.keys(tags).length > 0 ? tags : undefined,
                    "health_check_path": appData.deployments.deploymentOption === "visual" ? appData.deployments.healthCheckPath : undefined,
                    "auto_trigger": appData.basicDetails.enableAutoTrigger?.toString(),
                    "create_cron": appData.deployments.deploymentOption === "visual" ? (appData.deployments.taskSchedulers?.crons ? "true" : "false") : "false",
                    "create_queue_worker": appData.deployments.deploymentOption === "visual" ? (appData.deployments.taskSchedulers?.queuesAndWorkers ? "true" : "false") : "false",
                    "cron_command": appData.deployments.deploymentOption === "visual" ? String(appData.deployments.taskSchedulers?.entryPointCommandCrons ?? "") : "",
                    "queue_worker_command": appData.deployments.deploymentOption === "visual" ? String(appData.deployments.taskSchedulers?.entryPointCommandQueues ?? "") : "",
                    "pass_env_vars_at_build_time": currentProjectDep.tasks.find(x => x.serviceId === appData.serviceSelectedId).envs.some(x => x.injectAt.includes("Build Time") && x.lastAction !== "Delete").toString(),
                    "nodegroup_name": appData.deployments.deploymentOption === "visual" ? appData.deployments.nodeGroupName : undefined,
                    "nodegroup_type": appData.deployments.deploymentOption === "visual" ? appData.deployments.nodeGroupType : undefined,
                    "ingress_alb_enabled": appData.deployments.deploymentOption === "visual" ? appData.deployments.serviceType === "Existing Load Balancer(ALB Ingress)" ? "true" : "false" : undefined,//deploymentData.ingressAlbEnabled.toString(),
                    "acm_certificate": appData.deployments.deploymentOption === "visual" && appData.deployments.serviceType === "Existing Load Balancer(ALB Ingress)" ? acmCertificateForPayload(appData.deployments.acmCertificate) : undefined,
                    "list_of_nodegroups": appData.deployments.deploymentOption === "visual" ? (updatedData?.deploymentData?.provisioner === "imported" ? [] : appData.deployments.listOfNodegroups) : undefined,
                    "yaml_content": appData.deployments.deploymentOption === "yaml" ? appData.deployments.yamlData : undefined,
                    "yaml_kind": appData.deployments.deploymentOption === "yaml" ? appData.deployments.yamlType : undefined,
                    "labels": Object.keys(labels).length > 0 ? labels : undefined

                },
            };


            let envId
            envId = location.pathname.split('/').slice(-1)[0];

            dispatch({ loader: "envLoad", status: "loading" });
            // dispatch({ loader: "envLoad", status: "loaded" });
            console.log("Final payload: ", payload);
            api.post(`/api/project_env/update_service/${envId}/${appData.serviceSelectedId ?? appData.service_id}`, payload).then((res) => {
                let data = res.data;
                dispatch({ loader: "envLoad", status: "loaded" });
                console.log("data statusss:", data.status);

                if (data.status) {
                    toggleAlert("success", "Success", data.message);
                    // setUpdatedData({});
                    // setUpdateDep(false);
                    // localStorage.removeItem('updateDep');
                    // localStorage.removeItem('updatedData');
                    redirectToNext(services);
                    //navigate(`/environments/environment/${envId}`);
                    dispatch({ loader: "envLoad", status: "loaded" });
                }
                else {
                    if (typeof data.error_details === "object") {
                        if (data.error_details.services) {
                            console.log("Error...");
                            dispatch({ loader: "envLoad", status: "loaded" });
                            let myErrors = {};
                            Object.keys(data.error_details.services).map((val) => {
                                if (Object.keys(data.error_details.services[val]).length > 0) {
                                    myErrors = {
                                        ...myErrors,
                                        [val]: data.error_details.services[val]
                                    }
                                }
                            });
                            console.log("MY errors: ", myErrors);
                            for (const val of allForms) {

                                if (myErrors[val.serviceSelected]) {
                                    console.log("Val data source: ", val.form.getFieldWarning());

                                    val.form.setFields(
                                        Object.entries(myErrors[val.serviceSelected]).map(([field, err]) => ({
                                            name: field === "name" ? (snakeToCamel[field] in val.form.getFieldsValue()) ? snakeToCamel[field] : "appName" : snakeToCamel[field],
                                            //warnings: val.form.getFieldWarning()[snakeToCamel[field]],
                                            errors: err
                                        }))
                                    );

                                    // console.log("Val.form.getFields", val.form.getFieldsError());
                                    // console.log("Val.form.getFields", val.form.getFieldsError());
                                    // // val.form.validateFields(['displayName']).then((res) => {
                                    // //     console.log("Validated", res);
                                    // // }).catch((err) => {
                                    // //     console.log("All errors info: ", err);
                                    // // });
                                    // // val.form.validateFields().then(() => {
                                    // //     console.log("Validated", val.form.getFieldsError());
                                    // // }).catch((error) => {

                                    // // });
                                    // //val.form.validateFields();
                                    // console.log("Val.form.getFields", val.form.getFieldsError());
                                    // console.log("Val.form.getFields", val.form.getFieldsError());
                                }
                            }
                            console.log("All Forms: ", allForms[0].form.getFieldsError());
                            toggleAlert("error", "Update Service Failed", "Please enter correct information of the service to proceed.");
                            setFormErrors(myErrors);
                        }
                        else {
                            if (data.error_details.account_id) {
                                toggleAlert("error", "Failed", data.error_details.account_id);
                            }
                        }
                        dispatch({ loader: "envLoad", status: "loaded" });
                    }
                    else {
                        toggleAlert("error", "Failed", data.message);
                        dispatch({ loader: "envLoad", status: "loaded" });
                    }
                }
            }).catch((err) => {
                toggleAlert("error", "Failed", "Something went wrong. Please try again.");
                dispatch({ loader: "envLoad", status: "loaded" });
            });
        }
    }

    const handleMysqlRedeploy = (dataSources) => {
        let payload = {};
        const allForms = [{
            serviceSelected: dataSources.serviceName,
            form: deploymentForms[dataSources.serviceName]
        }];
        if (dataSources.type === "AWS Managed MySQL" || dataSources.type === "AWS Aurora Managed MySQL") {
            payload = {
                "name": dataSources.displayName,//"mysql",
                "service_id": dataSources.serviceSelectedId,//40,
                "config": {
                    "db_type": dataSources.type === "AWS Managed MySQL" ? "aws-rds-managed-mysql" : "aws-aurora-managed-mysql",
                    "mysql_instance_class": dataSources.cloudManaged.instanceType,//"db.t3.micro" , 
                    "Instance_family": dataSources.cloudManaged.instanceFamily,
                    "mysql_engine_version": dataSources.version,
                    "tags": dataSources.cloudManaged.tags.length === 1 ? (dataSources.cloudManaged.tags[0].name === "" || dataSources.cloudManaged.tags[0].value === "") ? [] : dataSources.cloudManaged.tags : dataSources.cloudManaged.tags,
                    "database_name": dataSources.cloudManaged.databaseName,//"nodeapp",        
                    "enable_multi_az": dataSources.cloudManaged.dbType === "Single DB Instance" ? "false" : "true", //"false",
                    "master_username": dataSources.cloudManaged.username,//"abhi",
                    "storage_size": parseInt(dataSources.cloudManaged.storageSize),//"30",       
                    "enable_public_access": dataSources.cloudManaged.enablePublicAccess ? "true" : "false",//"true",
                    "skip_final_snapshot": "true",
                    "backup_window": (dataSources.cloudManaged.backupTimingStart === "" || dataSources.cloudManaged.backupTimingEnd === "") ? "" : dataSources.cloudManaged.backupTimingStart + '-' + dataSources.cloudManaged.backupTimingEnd,//"03:00-06:00",
                    "backup_region": dataSources.cloudManaged.backupRegion,
                    "maintenance_window": (dataSources.cloudManaged.maintenanceWindowStart === "" || dataSources.cloudManaged.maintenanceWindowEnd === "") ? "" : dataSources.cloudManaged.maintenanceWindowDay.substring(0, 3).toLowerCase() + ':' + dataSources.cloudManaged.maintenanceWindowStart + '-' + dataSources.cloudManaged.maintenanceWindowDay.substring(0, 3).toLowerCase() + ':' + dataSources.cloudManaged.maintenanceWindowEnd,//"Mon:00:00-Mon:03:00",
                    "enable_deletion_protection": dataSources.cloudManaged.deletionProtection ? "true" : "false",//"false",
                    "backup_retention_period": dataSources.cloudManaged.backupRetention === "" ? "0" : dataSources.cloudManaged.backupRetention,//"7",
                    "enable_general_log": dataSources.cloudManaged.enableGeneralLogs ? "true" : "false",//"true",
                    "enable_slow_query_log": dataSources.cloudManaged.enableSlowLogs ? "true" : "false",//"true",
                    "create_random_password": dataSources.cloudManaged.autoGenPassword ? "true" : "false",//"true"
                    "master_password": dataSources.cloudManaged.password,
                    "log_retention_period": dataSources.cloudManaged.logRetention,
                    //"enable_backup": dataSources.cloudManaged.enableBackup ? "true" : 'false'
                    "private_subnet_ids": dataSources.cloudManaged.subnetIds.privateSubnets,
                    "public_subnet_ids": dataSources.cloudManaged.subnetIds.publicSubnets,
                }
            }
        }
        else {
            let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            let labelsMysql = {};
            dataSources.selfManaged.labels?.map((item, idx) => {
                if (item.name !== "" && item.value !== "") {
                    labelsMysql[item.name] = item.value;
                }
            })
            payload = {
                "name": dataSources.displayName,
                "service_id": dataSources.serviceSelectedId,//3,
                "config": {
                    "db_type": "self-managed-mysql",
                    //"architecture": val.selfManaged.dbType,//"standalone",
                    "storage_class_name": updatedData?.deploymentData?.provisioner !== "atmosly" ? "" : dataSources.selfManaged.storageType.toLowerCase() === "efs" ? "efs-sc" : dataSources.selfManaged.storageType.toLowerCase(),//"gp2",
                    "username": dataSources.selfManaged.username,//"admin",
                    "master_db_volume_size": dataSources.selfManaged.storageSize === "" ? "" : parseInt(dataSources.selfManaged.storageSize), //+ 'Gi',//"10Gi",
                    "secondary_db_volume_size": dataSources.selfManaged.storageSize === "" ? "" : parseInt(dataSources.selfManaged.storageSize), //+ 'Gi',//"10Gi",
                    "secondary_db_replica_count": dataSources.selfManaged.dbType.toString(),//"1",
                    "backup_enabled": dataSources.selfManaged.enableBackup ? "true" : "false",//"false",
                    "bucket_uri": "",
                    "enable_cross_region_backup": dataSources.selfManaged.enableCrossRegionBackup.toString(),
                    "bucket_region": dataSources.selfManaged.crossRegionBackup,//"",
                    //"backup_cron": "* * * * *",
                    "restore_db": "false",
                    "exporter_enable": dataSources.selfManaged.enableMetrics ? "true" : "false",//"true",
                    "app_version": dataSources.version,
                    "custom_credentials_enabled": !dataSources.selfManaged.autoGenPassword ? "true" : "false",//"true",
                    "store_password_to_secret_manager": "false",
                    "custom_user_password": dataSources.selfManaged.password,//"password",
                    "backup_frequency": dataSources.selfManaged.backupFrequency.toLowerCase(),//"hourly",
                    "backup_interval": dataSources.selfManaged.backupFrequency === "Weekly" ? days.indexOf(dataSources.selfManaged.backupDay) : dataSources.selfManaged.backupFrequency !== "Hourly" ? 1 : dataSources.selfManaged.backupInterval,//3,
                    "backup_time": dataSources.selfManaged.backupTiming,
                    "database_name": dataSources.selfManaged.databaseName,
                    "restore_file_name": "",
                    "list_of_nodegroups": updatedData?.deploymentData?.provisioner === "imported" ? [] : dataSources.selfManaged.listOfNodegroups,
                    "restore_db": dataSources.selfManaged.enableRestore ? "true" : "false",

                    "primary_cpu_limit": dataSources.selfManaged.limitCpuPrimary,
                    "primary_memory_limit": dataSources.selfManaged.limitMemPrimary,
                    "primary_cpu_request": dataSources.selfManaged.requestCpuPrimary,
                    "primary_memory_request": dataSources.selfManaged.requestMemPrimary,
                    "secondary_cpu_limit": dataSources.selfManaged.limitCpuSecondary,
                    "secondary_memory_limit": dataSources.selfManaged.limitMemSecondary,
                    "secondary_cpu_request": dataSources.selfManaged.requestCpuSecondary,
                    "secondary_memory_request": dataSources.selfManaged.requestMemSecondary,
                    "labels": Object.keys(labelsMysql).length > 0 ? labelsMysql : undefined
                }
            };
        }
        let envId
        envId = location.pathname.split('/').slice(-1)[0];

        dispatch({ loader: "envLoad", status: "loading" });
        api.post(`/api/project_env/update_service/${envId}/${dataSources.serviceSelectedId}`, payload).then((res) => {
            let data = res.data;

            if (data.status) {
                dispatch({ loader: "envLoad", status: "loaded" });
                toggleAlert("success", "Success", data.message);
                // setUpdatedData({});
                // setUpdateDep(false);
                // localStorage.removeItem('updateDep');
                // localStorage.removeItem('updatedData');
                redirectToNext();
                //navigate(`/environments/environment/${envId}`);
            }
            else {
                if (typeof data.error_details === "object") {
                    if (data.error_details.services) {
                        console.log("Error...");
                        dispatch({ loader: "envLoad", status: "loaded" });
                        let myErrors = {};
                        Object.keys(data.error_details.services).map((val) => {
                            if (Object.keys(data.error_details.services[val]).length > 0) {
                                myErrors = {
                                    ...myErrors,
                                    [val]: data.error_details.services[val]
                                }
                            }
                        });
                        console.log("MY errors: ", myErrors);
                        for (const val of allForms) {

                            if (myErrors[val.serviceSelected]) {
                                console.log("Val data source: ", val.form.getFieldWarning());

                                val.form.setFields(
                                    Object.entries(myErrors[val.serviceSelected]).map(([field, err]) => ({
                                        name: field === "name" ? (snakeToCamel[field] in val.form.getFieldsValue()) ? snakeToCamel[field] : "appName" : snakeToCamel[field],
                                        //warnings: val.form.getFieldWarning()[snakeToCamel[field]],
                                        errors: err
                                    }))
                                );

                                // console.log("Val.form.getFields", val.form.getFieldsError());
                                // console.log("Val.form.getFields", val.form.getFieldsError());
                                // // val.form.validateFields(['displayName']).then((res) => {
                                // //     console.log("Validated", res);
                                // // }).catch((err) => {
                                // //     console.log("All errors info: ", err);
                                // // });
                                // // val.form.validateFields().then(() => {
                                // //     console.log("Validated", val.form.getFieldsError());
                                // // }).catch((error) => {

                                // // });
                                // //val.form.validateFields();
                                // console.log("Val.form.getFields", val.form.getFieldsError());
                                // console.log("Val.form.getFields", val.form.getFieldsError());
                            }
                        }
                        console.log("All Forms: ", allForms[0].form.getFieldsError());
                        toggleAlert("error", "Update Service Failed", "Please enter correct information of the service to proceed.");
                        setFormErrors(myErrors);
                    }
                    else {
                        if (data.error_details.account_id) {
                            toggleAlert("error", "Failed", data.error_details.account_id);
                        }
                    }
                    dispatch({ loader: "envLoad", status: "loaded" });
                }
                else {
                    toggleAlert("error", "Failed", data.message);
                    dispatch({ loader: "envLoad", status: "loaded" });
                }
            }
        }).catch((err) => {
            toggleAlert("error", "Failed", "Something went wrong. Please try again.");
            dispatch({ loader: "envLoad", status: "loaded" });
        });
    }

    const handleMongoRedeploy = (dataSources) => {
        let payload = {};
        const allForms = [{
            serviceSelected: dataSources.serviceName,
            form: deploymentForms[dataSources.serviceName]
        }];
        if (dataSources.type === "Self Managed") {
            let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            let labelsMongo = {};
            dataSources.selfManaged.labels?.map((item, idx) => {
                if (item.name !== "" && item.value !== "") {
                    labelsMongo[item.name] = item.value;
                }
            })
            payload = {
                "name": dataSources.displayName,//"dskldss",
                "service_id": dataSources.serviceSelectedId,//6,
                "type": "self-managed-mongodb",
                "config": {
                    "db_type": "self-managed-mongodb",
                    //"architecture": val.selfManaged.dbType.toLowerCase(),//"standalone",
                    "storage_class_name": updatedData?.deploymentData?.provisioner !== "atmosly" ? "" : dataSources.selfManaged.storageType.toLowerCase() === "efs" ? "efs-sc" : dataSources.selfManaged.storageType.toLowerCase(),                            //"username": val.selfManaged.username,//"admin",
                    "volume_size": dataSources.selfManaged.storageSize === "" ? "" : parseInt(dataSources.selfManaged.storageSize), //+ 'Gi',//"10Gi",
                    //"secondary_db_volume_size": val.selfManaged.storageSize === "" ? "" : val.selfManaged.storageSize + 'Gi',//"10Gi",
                    "replica_count": dataSources.selfManaged.dbType === "" ? "" : dataSources.selfManaged.dbType.toString(),
                    //"replica_count": "1",
                    "backup_enabled": dataSources.selfManaged.enableBackup ? "true" : "false",//"false", //backup_enable
                    "bucket_uri": "",
                    "enable_cross_region_backup": dataSources.selfManaged.enableCrossRegionBackup.toString(),
                    "bucket_region": dataSources.selfManaged.crossRegionBackup,//"", //bucket_region
                    "restore_db": "false",
                    "exporter_enable": dataSources.selfManaged.enableMetrics ? "true" : "false",//"true",
                    //"mongodb_version": "",//"5.0.8-debian-10-r9", //later
                    "app_version": dataSources.version,
                    "custom_credentials_enabled": !dataSources.selfManaged.autoGenPassword ? "true" : "false",//"true",
                    "store_password_to_secret_manager": "false",
                    //"root_password": val.selfManaged.password,//"password",
                    "backup_frequency": dataSources.selfManaged.backupFrequency.toLowerCase(),//"hourly",
                    "backup_interval": dataSources.selfManaged.backupFrequency === "Weekly" ? days.indexOf(dataSources.selfManaged.backupDay) : dataSources.selfManaged.backupFrequency !== "Hourly" ? 1 : dataSources.selfManaged.backupInterval,//3,
                    "backup_time": dataSources.selfManaged.backupTiming,
                    "custom_database_name": dataSources.selfManaged.databaseName,
                    "custom_database_password": dataSources.selfManaged.password,
                    "custom_database_username": dataSources.selfManaged.username,//"abhi"
                    "list_of_nodegroups": updatedData?.deploymentData?.provisioner === "imported" ? [] : dataSources.selfManaged.listOfNodegroups,
                    "restore_db": dataSources.selfManaged.enableRestore ? "true" : "false",
                    "primary_cpu_limit": dataSources.selfManaged.limitCpuPrimary,
                    "primary_memory_limit": dataSources.selfManaged.limitMemPrimary,
                    "primary_cpu_request": dataSources.selfManaged.requestCpuPrimary,
                    "primary_memory_request": dataSources.selfManaged.requestMemPrimary,
                    "labels": Object.keys(labelsMongo).length > 0 ? labelsMongo : undefined
                }
            }
        }
        let envId;

        envId = location.pathname.split('/').slice(-1)[0];

        dispatch({ loader: "envLoad", status: "loading" });
        api.post(`/api/project_env/update_service/${envId}/${dataSources.serviceSelectedId}`, payload).then((res) => {
            let data = res.data;
            dispatch({ loader: "envLoad", status: "loaded" });

            if (data.status) {
                toggleAlert("success", "Success", data.message);
                // setUpdatedData({});
                // setUpdateDep(false);
                // localStorage.removeItem('updateDep');
                // localStorage.removeItem('updatedData');
                //navigate(`/environments/environment/${envId}`);
                redirectToNext();
            }
            else {
                if (typeof data.error_details === "object") {
                    if (data.error_details.services) {
                        console.log("Error...");
                        dispatch({ loader: "envLoad", status: "loaded" });
                        let myErrors = {};
                        Object.keys(data.error_details.services).map((val) => {
                            if (Object.keys(data.error_details.services[val]).length > 0) {
                                myErrors = {
                                    ...myErrors,
                                    [val]: data.error_details.services[val]
                                }
                            }
                        });
                        console.log("MY errors: ", myErrors);
                        for (const val of allForms) {

                            if (myErrors[val.serviceSelected]) {
                                console.log("Val data source: ", val.form.getFieldWarning());

                                val.form.setFields(
                                    Object.entries(myErrors[val.serviceSelected]).map(([field, err]) => ({
                                        name: field === "name" ? (snakeToCamel[field] in val.form.getFieldsValue()) ? snakeToCamel[field] : "appName" : snakeToCamel[field],
                                        //warnings: val.form.getFieldWarning()[snakeToCamel[field]],
                                        errors: err
                                    }))
                                );

                                // console.log("Val.form.getFields", val.form.getFieldsError());
                                // console.log("Val.form.getFields", val.form.getFieldsError());
                                // // val.form.validateFields(['displayName']).then((res) => {
                                // //     console.log("Validated", res);
                                // // }).catch((err) => {
                                // //     console.log("All errors info: ", err);
                                // // });
                                // // val.form.validateFields().then(() => {
                                // //     console.log("Validated", val.form.getFieldsError());
                                // // }).catch((error) => {

                                // // });
                                // //val.form.validateFields();
                                // console.log("Val.form.getFields", val.form.getFieldsError());
                                // console.log("Val.form.getFields", val.form.getFieldsError());
                            }
                        }
                        console.log("All Forms: ", allForms[0].form.getFieldsError());
                        toggleAlert("error", "Update Service Failed", "Please enter correct information of the service to proceed.");
                        setFormErrors(myErrors);
                    }
                    else {
                        if (data.error_details.account_id) {
                            toggleAlert("error", "Failed", data.error_details.account_id);
                        }
                    }
                    dispatch({ loader: "envLoad", status: "loaded" });
                }
                else {
                    toggleAlert("error", "Failed", data.message);
                    dispatch({ loader: "envLoad", status: "loaded" });
                }
            }
        }).catch((err) => {
            toggleAlert("error", "Failed", "Something went wrong. Please try again.");
            dispatch({ loader: "envLoad", status: "loaded" });
        });
    }

    const handleRedisRedeploy = (redisServiceData) => {
        let payload = {};
        const allForms = [{
            serviceSelected: redisServiceData.serviceName,
            form: deploymentForms[redisServiceData.serviceName]
        }];
        if (redisServiceData.type === "AWS Managed Redis") {
            payload = {
                "name": redisServiceData.displayName,
                "service_id": redisServiceData.serviceSelectedId,
                //"type": "elasticache-redis",
                "config": {
                    "db_type": "elasticache-redis",
                    "node_type": redisServiceData.cloudManaged.instanceType,
                    "Instance_family": redisServiceData.cloudManaged.instanceFamily,
                    //"family": "redis6.x",//will append the version to redis
                    "num_cache_nodes": redisServiceData.cloudManaged.noOfReplica.toString(),//"",
                    "multi_az_enabled": redisServiceData.cloudManaged.enableMultiAz ? "true" : "false",
                    "automatic_failover_enabled": redisServiceData.cloudManaged.enableAutomaticFailover ? "true" : "false",
                    "at_rest_encryption_enabled": redisServiceData.cloudManaged.enableRestEncryption ? "true" : "false",
                    "snapshot_retention_limit": redisServiceData.cloudManaged.backupRetention === "" ? "0" : redisServiceData.cloudManaged.backupRetention,//val.cloudManaged.backupRetention ? "true" : "false",
                    "transit_encryption_enabled": redisServiceData.cloudManaged.enableTransitEncryption ? "true" : "false",
                    "snapshot_window": (redisServiceData.cloudManaged.backupTimingStart === "" || redisServiceData.cloudManaged.backupTimingEnd === "") ? "" : redisServiceData.cloudManaged.backupTimingStart + '-' + redisServiceData.cloudManaged.backupTimingEnd,
                    "maintenance_window": (redisServiceData.cloudManaged.maintenanceWindowStart === "" || redisServiceData.cloudManaged.maintenanceWindowEnd === "") ? "" : redisServiceData.cloudManaged.maintenanceWindowDay.substring(0, 3).toLowerCase() + ':' + redisServiceData.cloudManaged.maintenanceWindowStart + '-' + redisServiceData.cloudManaged.maintenanceWindowDay.substring(0, 3).toLowerCase() + ':' + redisServiceData.cloudManaged.maintenanceWindowEnd,
                    "engine_version": redisServiceData.version,
                    "private_subnet_ids": redisServiceData.cloudManaged.subnetIds.privateSubnets,
                    "public_subnet_ids": redisServiceData.cloudManaged.subnetIds.publicSubnets,
                }
            }
        }
        else {
            let labelsRedis = {};
            redisServiceData.selfManaged.labels?.map((item, idx) => {
                if (item.name !== "" && item.value !== "") {
                    labelsRedis[item.name] = item.value;
                }
            })
            payload = {
                "name": redisServiceData.displayName,//"mks3",
                "service_id": redisServiceData.serviceSelectedId,//5,
                //"type": "self-managed-redis",
                "config": {
                    "db_type": "self-managed-redis",
                    //"architecture": "replication", //will add later
                    //"replicacount": "1", //will add later
                    "storage_class_name": updatedData?.deploymentData?.provisioner !== "atmosly" ? "" : redisServiceData.selfManaged.storageType.toLowerCase() === "efs" ? "efs-sc" : redisServiceData.selfManaged.storageType.toLowerCase(),//"gp2",
                    //"enable_metrics": val.selfManaged.enableMetrics ? "true" : "false",//"true",
                    "slave_volume_size": redisServiceData.selfManaged.storageSize === "" ? "" : parseInt(redisServiceData.selfManaged.storageSize), //+ "Gi",//"10Gi",
                    "master_volume_size": redisServiceData.selfManaged.storageSize === "" ? "" : parseInt(redisServiceData.selfManaged.storageSize), //+ "Gi",//"10Gi",
                    "slave_replica_count": redisServiceData.selfManaged.noOfReplica.toString(),//"2", //will add later
                    //"monitoring_enabled": "true", //will be added later
                    "app_version": redisServiceData.version,//"6.2.7-debian-11-r11", //version list update required
                    "store_password_to_secret_manager": "false",
                    "custom_credentials_enabled": redisServiceData.selfManaged.authEnabled ? redisServiceData.selfManaged.autoGenPassword ? "false" : "true" : undefined,
                    "password": redisServiceData.selfManaged.authEnabled ? redisServiceData.selfManaged.password : undefined,
                    "grafana_monitoring_enabled": redisServiceData.selfManaged.enableMetrics ? "true" : "false",
                    "list_of_nodegroups": updatedData?.deploymentData?.provisioner === "imported" ? [] : redisServiceData.selfManaged.listOfNodegroups,
                    "auth_enabled": redisServiceData.selfManaged.authEnabled ? redisServiceData.selfManaged.authEnabled.toString() : "false",
                    "primary_cpu_limit": redisServiceData.selfManaged.limitCpuPrimary,
                    "primary_memory_limit": redisServiceData.selfManaged.limitMemPrimary,
                    "primary_cpu_request": redisServiceData.selfManaged.requestCpuPrimary,
                    "primary_memory_request": redisServiceData.selfManaged.requestMemPrimary,
                    "secondary_cpu_limit": redisServiceData.selfManaged.limitCpuSecondary,
                    "secondary_memory_limit": redisServiceData.selfManaged.limitMemSecondary,
                    "secondary_cpu_request": redisServiceData.selfManaged.requestCpuSecondary,
                    "secondary_memory_request": redisServiceData.selfManaged.requestMemSecondary,
                    "labels": Object.keys(labelsRedis).length > 0 ? labelsRedis : undefined
                }
            };
        }
        let envId
        envId = location.pathname.split('/').slice(-1)[0];

        dispatch({ loader: "envLoad", status: "loading" });
        api.post(`/api/project_env/update_service/${envId}/${redisServiceData.serviceSelectedId}`, payload).then((res) => {
            let data = res.data;
            if (data.status) {
                dispatch({ loader: "envLoad", status: "loaded" });
                toggleAlert("success", "Success", data.message);
                // setUpdatedData({});
                // setUpdateDep(false);
                // localStorage.removeItem('updateDep');
                // localStorage.removeItem('updatedData');
                redirectToNext();
                //navigate(`/environments/environment/${envId}`);
            }
            else {
                if (typeof data.error_details === "object") {
                    if (data.error_details.services) {
                        console.log("Error...");
                        dispatch({ loader: "envLoad", status: "loaded" });
                        let myErrors = {};
                        Object.keys(data.error_details.services).map((val) => {
                            if (Object.keys(data.error_details.services[val]).length > 0) {
                                myErrors = {
                                    ...myErrors,
                                    [val]: data.error_details.services[val]
                                }
                            }
                        });
                        console.log("MY errors: ", myErrors);
                        for (const val of allForms) {

                            if (myErrors[val.serviceSelected]) {
                                console.log("Val data source: ", val.form.getFieldWarning());

                                val.form.setFields(
                                    Object.entries(myErrors[val.serviceSelected]).map(([field, err]) => ({
                                        name: field === "name" ? (snakeToCamel[field] in val.form.getFieldsValue()) ? snakeToCamel[field] : "appName" : snakeToCamel[field],
                                        //warnings: val.form.getFieldWarning()[snakeToCamel[field]],
                                        errors: err
                                    }))
                                );

                                // console.log("Val.form.getFields", val.form.getFieldsError());
                                // console.log("Val.form.getFields", val.form.getFieldsError());
                                // // val.form.validateFields(['displayName']).then((res) => {
                                // //     console.log("Validated", res);
                                // // }).catch((err) => {
                                // //     console.log("All errors info: ", err);
                                // // });
                                // // val.form.validateFields().then(() => {
                                // //     console.log("Validated", val.form.getFieldsError());
                                // // }).catch((error) => {

                                // // });
                                // //val.form.validateFields();
                                // console.log("Val.form.getFields", val.form.getFieldsError());
                                // console.log("Val.form.getFields", val.form.getFieldsError());
                            }
                        }
                        console.log("All Forms: ", allForms[0].form.getFieldsError());
                        toggleAlert("error", "Update Service Failed", "Please enter correct information of the service to proceed.");
                        setFormErrors(myErrors);
                    }
                    else {
                        if (data.error_details.account_id) {
                            toggleAlert("error", "Failed", data.error_details.account_id);
                        }
                    }
                    dispatch({ loader: "envLoad", status: "loaded" });
                }
                else {
                    toggleAlert("error", "Failed", data.message);
                    dispatch({ loader: "envLoad", status: "loaded" });
                }
            }
        }).catch((err) => {
            toggleAlert("error", "Failed", "Something went wrong. Please try again.");
            dispatch({ loader: "envLoad", status: "loaded" });
        });
    }


    const handlePostgresRedeploy = (dataSources) => {
        console.log("called the function!!!!!!");
        console.log("data sources!!", dataSources);

        let payload = {};
        const allForms = [{
            serviceSelected: dataSources.serviceName,
            form: deploymentForms[dataSources.serviceName]
        }];
        if (dataSources.type === "Self Managed") {
            let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            let labelsPostgres = {};
            dataSources.selfManaged.labels?.map((item, idx) => {
                if (item.name !== "" && item.value !== "") {
                    labelsPostgres[item.name] = item.value;
                }
            })
            payload = {
                "name": dataSources.displayName,//"mks2",
                "service_id": dataSources.serviceSelectedId,//69,
                "config": {
                    "db_type": "self-managed-postgresql",
                    "postgresql_exporter_enabled": dataSources.selfManaged.enableExporter ? "true" : "false",//"false",
                    "replicacount": dataSources.selfManaged.dbType.toString(),//"1",
                    "storage_class_name": updatedData?.deploymentData?.provisioner !== "atmosly" ? "" : dataSources.selfManaged.storageType.toLowerCase() === "efs" ? "efs-sc" : dataSources.selfManaged.storageType.toLowerCase(),//"gp2",
                    "custom_credentials_enabled": dataSources.selfManaged.autoGenPassword ? "false" : "true",//"false",
                    "postgresql_password": dataSources.selfManaged.password, //"",
                    "app_version": dataSources.version,//"16.0.0",
                    "database_name": dataSources.selfManaged.databaseName,//"atmosly",
                    "storage_size": !dataSources.selfManaged.storageSize ? "" : parseInt(dataSources.selfManaged.storageSize),//"10Gi"
                    "postgresql_username": dataSources.selfManaged.username,
                    "backup_enabled": dataSources.selfManaged.enableBackup ? "true" : "false",
                    "backup_frequency": dataSources.selfManaged.backupFrequency.toLowerCase(),
                    "backup_interval": dataSources.selfManaged.backupFrequency === "Weekly" ? days.indexOf(dataSources.selfManaged.backupDay) : dataSources.selfManaged.backupFrequency !== "Hourly" ? 1 : dataSources.selfManaged.backupInterval,
                    "backup_time": dataSources.selfManaged.backupTiming,
                    "enable_cross_region_backup": dataSources.selfManaged.enableCrossRegionBackup.toString(),
                    "bucket_region": dataSources.selfManaged.crossRegionBackup,
                    "list_of_nodegroups": updatedData?.deploymentData?.provisioner === "imported" ? [] : dataSources.selfManaged.listOfNodegroups,
                    "restore_db": dataSources.selfManaged.enableRestore ? "true" : "false",
                    "primary_cpu_limit": dataSources.selfManaged.limitCpuPrimary,
                    "primary_memory_limit": dataSources.selfManaged.limitMemPrimary,
                    "primary_cpu_request": dataSources.selfManaged.requestCpuPrimary,
                    "primary_memory_request": dataSources.selfManaged.requestMemPrimary,
                    "secondary_cpu_limit": dataSources.selfManaged.limitCpuSecondary,
                    "secondary_memory_limit": dataSources.selfManaged.limitMemSecondary,
                    "secondary_cpu_request": dataSources.selfManaged.requestCpuSecondary,
                    "secondary_memory_request": dataSources.selfManaged.requestMemSecondary,
                    "labels": Object.keys(labelsPostgres).length > 0 ? labelsPostgres : undefined
                }
            };
            console.log("Enters for payload gen...", payload);
        }
        else {
            payload = {
                "name": dataSources.displayName,//"mysql",
                "service_id": dataSources.serviceSelectedId,//40,
                "config": {
                    "db_type": dataSources.type === "AWS Managed Postgres" ? "aws-rds-managed-postgres" : "aws-aurora-managed-postgres",
                    "instance_type": dataSources.cloudManaged.instanceType,//"db.t3.micro" , 
                    "Instance_family": dataSources.cloudManaged.instanceFamily,
                    "engine_version": dataSources.version,
                    "tags": dataSources.cloudManaged.tags.length === 1 ? (dataSources.cloudManaged.tags[0].name === "" || dataSources.cloudManaged.tags[0].value === "") ? [] : dataSources.cloudManaged.tags : dataSources.cloudManaged.tags,
                    "database_name": dataSources.cloudManaged.databaseName,//"nodeapp",        
                    "enable_multi_az": dataSources.cloudManaged.dbType === "Single DB Instance" ? "false" : "true", //"false",
                    "master_username": dataSources.cloudManaged.username,//"abhi",
                    "storage_size": parseInt(dataSources.cloudManaged.storageSize),//"30",       
                    "enable_public_access": dataSources.cloudManaged.enablePublicAccess ? "true" : "false",//"true",
                    "skip_final_snapshot": "true",
                    "backup_window": dataSources.type === "AWS Aurora Managed Postgres" || dataSources.type === "AWS Managed Postgres" ? (dataSources.cloudManaged.backupTimingStart === "" || dataSources.cloudManaged.backupTimingEnd === "") ? "" : dataSources.cloudManaged.backupTimingStart + '-' + dataSources.cloudManaged.backupTimingEnd :
                        (dataSources.cloudManaged.backupTimingStart === "" || dataSources.cloudManaged.backupTimingEnd === "") ? "" : dataSources.cloudManaged.backupTimingStart + '-' + dataSources.cloudManaged.backupTimingEnd,//"03:00-06:00",
                    "maintenance_window": (dataSources.cloudManaged.maintenanceWindowStart === "" || dataSources.cloudManaged.maintenanceWindowEnd === "") ? "" : dataSources.cloudManaged.maintenanceWindowDay.substring(0, 3).toLowerCase() + ':' + dataSources.cloudManaged.maintenanceWindowStart + '-' + dataSources.cloudManaged.maintenanceWindowDay.substring(0, 3).toLowerCase() + ':' + dataSources.cloudManaged.maintenanceWindowEnd,//"Mon:00:00-Mon:03:00",
                    "enable_deletion_protection": dataSources.cloudManaged.deletionProtection ? "true" : "false",//"false",
                    "backup_retention_period": dataSources.cloudManaged.backupRetention === "" ? "0" : dataSources.cloudManaged.backupRetention,//"7",
                    "enable_general_log": dataSources.cloudManaged.enableGeneralLogs ? "true" : "false",//"true",
                    "enable_slow_query_log": dataSources.cloudManaged.enableSlowLogs ? "true" : "false",//"true",
                    "create_random_password": dataSources.cloudManaged.autoGenPassword ? "true" : "false",//"true"
                    "master_password": dataSources.cloudManaged.password,
                    "log_retention_period": dataSources.cloudManaged.logRetention,
                    //"enable_backup": dataSources.cloudManaged.enableBackup ? "true" : 'false'
                    "private_subnet_ids": dataSources.cloudManaged.subnetIds.privateSubnets,
                    "public_subnet_ids": dataSources.cloudManaged.subnetIds.publicSubnets,
                }
            }
        }

        // Send the API request
        let envId
        envId = location.pathname.split('/').slice(-1)[0];
        dispatch({ loader: "envLoad", status: "loading" });
        console.log("My final payload...", payload);
        api.post(`/api/project_env/update_service/${envId}/${dataSources.serviceSelectedId}`, payload)
            .then((res) => {
                dispatch({ loader: "envLoad", status: "loaded" });
                let data = res.data;
                if (data.status) {
                    toggleAlert("success", "Success", data.message);
                    redirectToNext();
                } else {
                    if (typeof data.error_details === "object") {
                        if (data.error_details.services) {
                            console.log("Error...");
                            dispatch({ loader: "envLoad", status: "loaded" });
                            let myErrors = {};
                            Object.keys(data.error_details.services).map((val) => {
                                if (Object.keys(data.error_details.services[val]).length > 0) {
                                    myErrors = {
                                        ...myErrors,
                                        [val]: data.error_details.services[val]
                                    }
                                }
                            });
                            console.log("MY errors: ", myErrors);
                            for (const val of allForms) {

                                if (myErrors[val.serviceSelected]) {
                                    console.log("Val data source: ", val.form.getFieldWarning());

                                    val.form.setFields(
                                        Object.entries(myErrors[val.serviceSelected]).map(([field, err]) => ({
                                            name: field === "name" ? (snakeToCamel[field] in val.form.getFieldsValue()) ? snakeToCamel[field] : "appName" : snakeToCamel[field],
                                            //warnings: val.form.getFieldWarning()[snakeToCamel[field]],
                                            errors: err
                                        }))
                                    );

                                    // console.log("Val.form.getFields", val.form.getFieldsError());
                                    // console.log("Val.form.getFields", val.form.getFieldsError());
                                    // // val.form.validateFields(['displayName']).then((res) => {
                                    // //     console.log("Validated", res);
                                    // // }).catch((err) => {
                                    // //     console.log("All errors info: ", err);
                                    // // });
                                    // // val.form.validateFields().then(() => {
                                    // //     console.log("Validated", val.form.getFieldsError());
                                    // // }).catch((error) => {

                                    // // });
                                    // //val.form.validateFields();
                                    // console.log("Val.form.getFields", val.form.getFieldsError());
                                    // console.log("Val.form.getFields", val.form.getFieldsError());
                                }
                            }
                            console.log("All Forms: ", allForms[0].form.getFieldsError());
                            toggleAlert("error", "Update Service Failed", "Please enter correct information of the service to proceed.");
                            setFormErrors(myErrors);
                        }
                        else {
                            if (data.error_details.account_id) {
                                toggleAlert("error", "Failed", data.error_details.account_id);
                            }
                        }
                        dispatch({ loader: "envLoad", status: "loaded" });
                    }
                    else {
                        dispatch({ loader: "envLoad", status: "loaded" });
                        toggleAlert("error", "Failed", data.message);
                    }
                }
            })
            .catch((err) => {
                toggleAlert("error", "Failed", "Something went wrong. Please try again.");
                dispatch({ loader: "envLoad", status: "loaded" });
            });
    }
    // const handleThirdPartyDataServiceStop = (updatedThirdpartyData, title = null) => {
    //     console.log("selected service id=====", updatedThirdpartyData.serviceSelectedId)
    //     let envId;
    //     envId = location.pathname.split('/').slice(-3)[0];

    //     dispatch({ loader: "envLoad", status: "loading" });

    //     api.get(`/api/project_env/stop-data-service/stop/${envId}/${updatedThirdpartyData.serviceSelectedId}`)
    //         .then((res) => {
    //             dispatch({ loader: "envLoad", status: "loaded" });
    //             let data = res.data;
    //             if (data.status && title === "Are you sure you want to Stop the service?") {
    //                 toggleAlert("success", "Success", data.message);
    //                 dispatch({ loader: "envLoad", status: "loaded" });
    //             }
    //             else if (data.status) {
    //                 toggleAlert("success", "Success", data.message);
    //                 redirectToNext(services);
    //             } else {
    //                 toggleAlert("error", "Failed", data.message);
    //             }
    //         })
    //         .catch((err) => {
    //             toggleAlert("error", "Failed", "Something went wrong. Please try again.");
    //             dispatch({ loader: "envLoad", status: "loaded" });
    //         });
    // }
    // const handleThirdPartyDataServiceStart = (updatedThirdpartyData, title = null) => {
    //     console.log("selected service id=====", updatedThirdpartyData.serviceSelectedId)
    //     let envId;
    //     envId = location.pathname.split('/').slice(-3)[0];

    //     dispatch({ loader: "envLoad", status: "loading" });

    //     api.get(`/api/project_env/stop-data-service/start/${envId}/${updatedThirdpartyData.serviceSelectedId}`)
    //         .then((res) => {
    //             dispatch({ loader: "envLoad", status: "loaded" });
    //             let data = res.data;
    //             if (data.status && title === "Are you sure you want to Start the service?") {
    //                 toggleAlert("success", "Success", data.message);
    //                 dispatch({ loader: "envLoad", status: "loaded" });
    //             }
    //             else if (data.status) {
    //                 toggleAlert("success", "Success", data.message);
    //                 redirectToNext(services);
    //             } else {
    //                 toggleAlert("error", "Failed", data.message);
    //             }
    //         })
    //         .catch((err) => {
    //             toggleAlert("error", "Failed", "Something went wrong. Please try again.");
    //             dispatch({ loader: "envLoad", status: "loaded" });
    //         });
    // }

    const handleServiceStop = (updatedThirdpartyData, title = null) => {
        console.log("selected service id=====", updatedThirdpartyData.serviceSelectedId)
        let envId;
        envId = location.pathname.split('/').slice(-3)[0];
        dispatch({ loader: "envLoad", status: "loading" });

        api.get(`/api/project_env/stop-start-service/stop/${envId}/${updatedThirdpartyData.serviceSelectedId}`)
            .then((res) => {
                dispatch({ loader: "envLoad", status: "loaded" });
                let data = res.data;
                if (data.status && title === "Are you sure you want to Stop the service?") {
                    toggleAlert("success", "Success", data.data.message);
                    dispatch({ loader: "envLoad", status: "loaded" });
                    setToggleApi(toggleApi => !toggleApi);
                }
                else {
                    toggleAlert("error", "Failed", data.message);
                }
            })
            .catch((err) => {
                toggleAlert("error", "Failed", "Something went wrong. Please try again.");
                dispatch({ loader: "envLoad", status: "loaded" });
            });
    }

    const handleServiceStart = (updatedThirdpartyData, title = null) => {
        console.log("selected service id=====", updatedThirdpartyData.serviceSelectedId)
        let envId;
        envId = location.pathname.split('/').slice(-3)[0];
        dispatch({ loader: "envLoad", status: "loading" });

        api.get(`/api/project_env/stop-start-service/start/${envId}/${updatedThirdpartyData.serviceSelectedId}`)
            .then((res) => {
                dispatch({ loader: "envLoad", status: "loaded" });
                let data = res.data;
                if (data.status && title === "Are you sure you want to Start the service?") {
                    toggleAlert("success", "Success", data.data.message);
                    dispatch({ loader: "envLoad", status: "loaded" });
                    setToggleApi(toggleApi => !toggleApi);
                }
                else {
                    toggleAlert("error", "Failed", data.message);
                }
            })
            .catch((err) => {
                toggleAlert("error", "Failed", "Something went wrong. Please try again.");
                dispatch({ loader: "envLoad", status: "loaded" });
            });
    }

    return { handleApplicationRedeploy, handleMysqlRedeploy, handleMongoRedeploy, handleRedisRedeploy, handlePostgresRedeploy, toggleAlert, handleServiceStop, handleServiceStart };
}